require("./snippets/accordion");
require("./snippets/product-quick-view-modal");
require("./qf/global_listeners");
require("./qf/wishlistAsObject");
require("./qf/cart");
require("./snippets/currency-selector");
require("./snippets/account-activation");
require("./sections/instalment-plans");
require("./snippets/nested-accordions");
require("./snippets/back-in-stock");

window.wishlist = new WishlistObjectQf();
window.globalListeners = new GlobalListeners();
window.cart = new CartQf();